/**
 * La marca de «esto se te quedó sin cerrar».
 *
 * Un triángulo ámbar junto a la fecha, en todas las listas donde aparece una
 * cita: la tabla, las clases y el historial del cliente. Vive aquí y no copiado
 * en cada una porque el color y las palabras tienen que ser los mismos en los
 * tres sitios —una advertencia que se dice distinto según dónde estés deja de
 * leerse como advertencia—.
 *
 * En el calendario no se usa: allí la casilla es diminuta y lo que avisa es el
 * borde de la propia tarjeta.
 */
import { IconAlertTriangle } from '@tabler/icons-react'

import { OVERDUE_HINT_KEY, needsOutcome } from './bookingShared'
import { useI18n } from '../../../lib/i18n'

export function BookingOverdueMark({ booking, size = 13, label }: {
  booking: { endsAt: string; status: string }
  size?: number
  /** Lo que dice la marca. Sin nada, el aviso común de toda la agenda. */
  label?: string | undefined
}) {
  /* El hook va antes del `return null`: en React el orden de los hooks no puede
     depender de los datos, y esto se pinta o no según la reserva. */
  const { t } = useI18n()
  if (!needsOutcome(booking)) return null
  const hint = label ?? t(OVERDUE_HINT_KEY)
  /* El texto va en `title` y en `aria-label`: el icono solo es color, y el color
     solo no dice qué pasa ni lo lee un lector de pantalla. */
  return (
    <span className="dash-booking-overdue" title={hint} aria-label={hint} role="img">
      <IconAlertTriangle size={size} aria-hidden="true" />
    </span>
  )
}
